import config from './config'
export default {
	home: {
		en: 'Home',
		es: 'Inicio'
	},
	login: {
		en: 'Login',
		es: 'Iniciar sesión'
	},
	purchases: {
		en: 'Offers',
		es: 'Oferta'
	},
	'purchase-simulation': {
		en: 'Offer simulation',
		es: 'Oferta simulación'
	},
	'experimental-simulation': {
		en: 'Experimental simulation',
		es: 'Simulación experimental'
	},
	receiving: {
		en: 'Purchases',
		es: 'Compras'
	},
	sales: {
		en: 'Sales',
		es: 'Ventas'
	},
	'production-orders': {
		en: 'Production orders',
		es: 'Órdenes de producción'
	},
	'order-results': {
		en: 'Order results',
		es: 'Orden De Trabajo'
	},
	'material-journals': {
		en: 'Material journals',
		es: 'Diarios de materiales'
	},
	'receiving-journals': {
		en: 'Receiving journals',
		es: 'Recepción de los diarios'
	},
	'raw-cardamom-sorting-journals': {
		// en: 'Before sorting journals',
		// es: 'Antes de clasificar los diarios'
		en: `${config['raw-cardamom-sorting-journals'].en}`,
		es: `${config['raw-cardamom-sorting-journals'].es}`
	},
	'cardamom-sorting-journals': {
		// en: 'After sorting journals',
		// es: 'Después de clasificar los diarios'
		en: `${config['cardamom-sorting-journals'].en}`,
		es: `${config['cardamom-sorting-journals'].es}`
	},
	'delivery-journals': {
		en: 'Delivery journals',
		es: 'Diarios de entrega'
	},
	inventory: {
		en: 'Inventory',
		es: 'Inventario'
	},
	'items-statement': {
		en: 'Items statement',
		es: 'Estado de los artículos'
	},
	statistics: {
		en: 'Statistics',
		es: 'Estadísticas'
	},
	accounts: {
		en: 'Accounts',
		es: 'Cuentas'
	},
	account: {
		en: 'Account',
		es: 'Cuenta'
	},
	items: {
		en: 'items',
		es: 'artículos'
	},
	item: {
		en: 'item',
		es: 'artículo'
	},
	'roles-management': {
		en: 'Roles management',
		es: 'Gestión de roles'
	},
	role: {
		en: 'Role',
		es: 'Rol'
	},
	'general-settings': {
		en: 'General settings',
		es: 'Configuración general'
	},
	'material-simulation': {
		en: 'Simulation',
		es: 'Simulación'
	},
	'fiscal-years': {
		en: 'Fiscal years',
		es: 'Años fiscal'
	},
	compare: {
		en: 'Compare',
		es: 'Comparar'
	}
}